import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@app/shared/shared.module';
import { CKWebLibModule, LibNoteService } from '@care-connect-japan/ckweblib';
import { environment } from 'src/environments/environment';
import { AliasListComponent } from './alias-list/alias-list.component';
import { DropdownArrowComponent } from './dropdown-arrow/dropdown-arrow.component';
import { RecordCreateFormComponent } from './record-create-form/record-create-form.component';
import { RecordDeleteComponent } from './record-delete/record-delete.component';
import { RecordFieldComponent } from './record-field/record-field.component';
import { RecordSelectItemComponent } from './record-select-item/record-select-item.component';
import { RecordSelectModalComponent } from './record-select/record-select-modal.component';
import { RecordSelectComponent } from './record-select/record-select.component';
import { ScheduleFieldComponent } from './schedule-field/schedule-field.component';
import { SearchSelectFieldComponent } from './search-select-field/search-select-field.component';
import { SearchSelectComponent } from './search-select/search-select.component';
import { SelectItemComponent } from './select-item/select-item.component';
import { SuccessDialogTemplateComponent } from './success-dialog-template/success-dialog-template.component';
import { StaffSearchSelectComponent } from './search-select/staff-search/staff-search-select.component';
import { DaiSearchSelectComponent } from './search-select/dai-search/dai-search-select.component';
import { SlideUpWindowComponent } from './slide-up-window/slide-up-window.component';
import { RoomItemComponent } from './slide-up-window/room-item/room-item.component';
import { SlideUpWindowByStudentComponent } from './slide-up-window-by-student/slide-up-window-by-student.component';
import { RoomItemByStudentComponent } from './slide-up-window-by-student/room-item-by-student/room-item-by-student.component';

const components = [
  SuccessDialogTemplateComponent,
  RecordCreateFormComponent,
  DropdownArrowComponent,
  SearchSelectComponent,
  SearchSelectFieldComponent,
  ScheduleFieldComponent,
  RecordFieldComponent,
  RecordDeleteComponent,
  RecordSelectItemComponent,
  RecordSelectComponent,
  RecordSelectModalComponent,
  SelectItemComponent,
  AliasListComponent,
  DaiSearchSelectComponent,
  StaffSearchSelectComponent,
  SlideUpWindowComponent,
  RoomItemComponent,
  SlideUpWindowByStudentComponent,
  RoomItemByStudentComponent
];

@NgModule({
  declarations: [components],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    CKWebLibModule.forRoot({ apiUrl: environment.KIDS_CLIENT_API, canAccessLocalStorage: 1 }),
  ],
  exports: [components, CKWebLibModule],
  providers: [LibNoteService],
})
export class ComponentsSharedModule { }
